import CustomersDirectoryPage from '@/pages/customers/customers-directory-page'

export default function JobCustomersPage() {
  return <CustomersDirectoryPage context="jobs" />
}
